import { render, staticRenderFns } from "./DialogAdd.vue?vue&type=template&id=66367cb2&scoped=true&"
import script from "./DialogAdd.vue?vue&type=script&lang=js&"
export * from "./DialogAdd.vue?vue&type=script&lang=js&"
import style0 from "./DialogAdd.vue?vue&type=style&index=0&id=66367cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66367cb2",
  null
  
)

export default component.exports